import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import VueCompositionApi from "@vue/composition-api";
import DatetimePicker from "vuetify-datetime-picker";
import VueFlags from "@growthbunker/vueflags";

import { number_format } from "./utils";
//import "vuetify-datetime-picker/src/stylus/main.styl";
import "leaflet/dist/leaflet.css";
import "./components/carto/_globals";
import Row from "./components/Row";
import { i18n } from "./plugins/i18n";

Vue.use(DatetimePicker);
Vue.use(VueCompositionApi);
Vue.use(VueFlags, {
  iconPath: "/flags/"
});
Vue.config.productionTip = false;
Vue.component(Row.name, Row);

Vue.filter("number_format", value => {
  return number_format(value, 0, ",", " ");
});

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App)
}).$mount("#app");
